
export const avaatUudenSivunLyrics =
`# 1.SÄK	
Avaat uuden sivun
Elämäni kirjassa
Sulla oli suunnitelma
Aina minun varalta
Rakkautesi sydämeni valloittaa
Uuden tarinan kirjoittaa

# KERTSI
Tahdon haaveeni kanssasi jakaa
Juosta vierelläsi vastavirtaan
Jeesus auta mua toteuttamaan
Sun suunnitelmaa
Tahdon Sinussa vaikeudet kohtaa
Koetuksien läpi kulkea
Jeesus auta mua muistamaan
Rakkautes hintaa

# 2.SÄK
Herkkään saviastiaan
Sinä asetuit asumaan
Voimas heikkoudessani
Tulee täydelliseksi
Rakkautesi valloittaa mut kokonaan
Mun sydämen puhdistaa

# KERTSI
Tahdon haaveeni kanssasi jakaa
Juosta vierelläsi vastavirtaan
Jeesus auta mua toteuttamaan
Sun suunnitelmaa
Tahdon Sinussa vaikeudet kohtaa
Koetuksien läpi kulkea
Jeesus auta mua muistamaan
Rakkautes hintaa

# C-OSA
Tietää saan
Kuinka paljon mua Sä rakastat
Tietää saan
Jeesus
Tietää saan
Kuinka paljon mua Sä rakastat
Tietää saan

# KERTSI
Tahdon haaveeni kanssasi jakaa
Juosta vierelläsi vastavirtaan
Jeesus auta mua toteuttamaan
Sun suunnitelmaa

# C-OSA 
Tietää saan
Kuinka paljon mua Sä rakastat
Tietää saan
Jeesus (Tahdon Sinussa vaikeudet voittaa)
Tietää saan
Kuinka paljon mua Sä rakastat
Tietää saan

# OUTRO
Jeesus auta mua muistamaan
Rakkautes hintaa`;

export const keskenerasiiTaideteoksiiLyrics = 
`# 1.SÄK
Hei, ei se haittaa vaikket aina jaksaiskaan
Ei, ei se haittaa vaik kyynelii valuu taas

# BRIDGE
Mä tiiän nyt on vaikeeta
Mut vaikeuksista syntyy vain kaunista

# 2.SÄK
Hei, sust voi tuntuu ettet onnistuis ollenkaan
Ja ei, ei sun arvos siihen perustunutkaan

# BRIDGE
Mä tiiän nyt on vaikeeta
Mut vaikeuksista syntyy vain kaunista

# KERTSI 
Jos sä katsoisit peiliin hieman rakastavammin
Ehkä huomaisit saman kuin minäkin 
Jos sä katsoisit kuvaas vähän armahtavammin
Ehkä huomaisit siellä enkelin

# 3.SÄK
Me, kaikki ollaan täysin keskeneräsii
Ja siks, voit huoles luottaa taivaan Isän käsiin

# BRIDGE
Mä tiiän nyt on vaikeeta 
Mut kyyneleistä kasvaa aina kaunista 

# KERTSI 
Jos sä katsoisit peiliin hieman rakastavammin
Ehkä huomaisit saman kuin minäkin 
Jos sä katsoisit kuvaas vähän armahtavammin
Ehkä huomaisit siellä enkelin
Ehkä huomaisit siellä enkelin

# C-OSA
Ollaan keskeneräsii 
Isän taideteoksii
Ja juuri siks ollaan täydellisii x2

# BRIDGE
Mä tiiän nyt on vaikeeta 
Mut kyyneleistä kasvaa aina kaunista 

# KERTSI
Jos sä katsoisit peiliin hieman rakastavammin
Ehkä huomasit saman kuin minäkin 
Jos sä katsoisit peiliin hieman rakastavammin
Ehkä huomaisit siellä enkelin`;

export const saAnnatMulleKaikenLyrics =
`# 1.SÄK	
Tuun eteesi
Painan pääni
Ymmärtänyt oon 
Oot suurin Herrani

# 2.SÄK
Tuon eteesi
Kaikki huoleni
Haluun olla vaan
Sua lähellä lähellä Jeesus 

# BRIDGE
Vaikka mitään en mä ansaitse 
Annoit rakkauden

# KERTSI
Sä annat mulle voiman
annat mulle leivän
annat mulle kaiken mitä mul on
Annat mulle rauhan
annat mulle toivon 
annat mulle kaiken mitä mä oon
Ja mä oon Sun

# 3. SÄK
Ilman sun rakkauttas
Olisin hukassa
Vailla mitään suunnitelmaa
Seinä tulee mua vastaan
Sä oot ainoo joka voi mut pelastaa

# BRIDGE
Vaikka mitään en mä ansaitse 
Annoit rakkauden

# KERTSI
Sä annat mulle voiman
annat mulle leivän
annat mulle kaiken mitä mul on
Annat mulle rauhan
Annat mulle toivon 
Annat mulle kaiken mitä mä oon x2

# C-OSA
Olet täydellinen rakkaus x4

# OUTRO
Vaikka mitään en mä ansaitse 
Annoit rakkauden`;